import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTranslate, useDataProvider, Title, usePermissions, Loading } from 'react-admin';
import { useAuthProvider } from 'ra-core';
import PageListLabel from '../page-list-label';
import UserTable from './listContentUser';
import Snackbar from '../common/snackbar';
import { useLocation } from "react-router-dom";

let timeoutDelete = null;
export const UserList = ({ }) => {
    const authProvider = useAuthProvider();
    const location = useLocation();
    const { permissions, loaded } = usePermissions();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

    // STATE
    const [isPermission, setIsPermission] = useState(true);
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [search, setSearchText] = useState('');
    const [showSnackbarDelete, setShowSnackbarDelete] = useState(false);
    const [showSnackbarEdit, setShowSnackbarEdit] = useState(false);
    const [showSnackbarCreate, setShowSnackbarCreate] = useState(false);
    const [pagination, setPagination] = useState({ page: 0, perPage: 10 });
    const [order, setOrder] = useState({ field: 'username', order: 'ASC' });
    // END STATE

    const getListUser = () => {
        let filter = { text: search.trim() };
        // if (search.trim() && search.length > 0) {
        //     filter = {

        //         or: [
        //             { username: { contains: search.trim() }, isDeleted: false },
        //             { firstName: { contains: search.trim() }, isDeleted: false },
        //             { lastName: { contains: search.trim() }, isDeleted: false },
        //             { organisation: { contains: search.trim() }, isDeleted: false },
        //             { email: { contains: search.trim() }, isDeleted: false },

        //         ]
        //     };

        //     // Avoid checking type of sails
        //     // For type number field
        //     if (!isNaN(search.trim())) {
        //         filter.or.push(...[
        //             { phoneNumber: { contains: search.trim() }, isDeleted: false },
        //         ]);
        //     }
        // }
        dataProvider('GET_LIST', "users", {
            filter,
            pagination: {
                page: pagination.page + 1,
                perPage: pagination.perPage
            },
            sort: order,
        }).then(response => {
            if (response.success) {
                setUser(response.data);
                setTotalCount(response.total);
            }
        }).catch(error => {
            if (error.message === 'permissionIncorect') {
                setIsPermission(false)
                authProvider.resetFunctionAction()
            }
        });
    }

    const handleDelete = (item) => {
        setShowSnackbarDelete(true);
        const newUsers = user.filter(userItem => userItem.id !== item.id);
        setUser(newUsers);

        timeoutDelete = setTimeout(() => {
            setShowSnackbarDelete(false);

            dataProvider('DELETE', 'users', {
                id: item.id
            }).then((data) => {
                getListUser();
            }).catch(error => {
                // TODO: Should show error message
                if (error.message === 'permissionIncorect') {
                    setIsPermission(false)
                }
                console.log('Submit user error:', error);
            });
        }, 6000);
    };

    const undoDeleteUser = () => {
        clearTimeout(timeoutDelete);
        setShowSnackbarDelete(false);
        getListUser();
    }

    useEffect(() => {
        getListUser();
        setLoading(false);
    }, [pagination, order]);

    useEffect(() => {
        if (location.state && location.state.open === true) {
            setShowSnackbarEdit(true);
            setTimeout(() => {
                setShowSnackbarEdit(false);
            }, 6000);
        }
        if (location.state && location.state.openCreate === true) {
            setShowSnackbarCreate(true);
            setTimeout(() => {
                setShowSnackbarCreate(false);
            }, 6000);
        }
    }, []);
    if (loading) return <Loading />;
    if (!loaded) return null

    // console.log("location.name showSnackbarDelete showSnackbarEdit", showSnackbarDelete)

    return (
        <Box mt={5} py={2} width={!isDesktop ? '95%' : '80%'} m='auto'>
            <Snackbar
                show={showSnackbarDelete}
                message={translate('pos.user.deleteUser')}
                undo={undoDeleteUser}
                onClose={() => setShowSnackbarDelete(false)}
            />
            <Snackbar
                show={showSnackbarEdit}
                boldText={location.state && location.state.name}
                message={translate('pos.user.editUser')}
                onClose={() => setShowSnackbarEdit(false)}
            />
            <Snackbar
                show={showSnackbarCreate}
                boldText={location.state && location.state.name}
                message={translate('pos.user.createUser')}
                onClose={() => setShowSnackbarCreate(false)}
            />
            <Title title={translate(`pos.user.title`)} />
            <PageListLabel
                label={translate('pos.user.name')}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'Admin rights/functions' && value.isCreate)
                }
                searchPlaceholder={translate('pos.user.search')}
                btnText={translate('pos.user.create')}
                onChangeText={setSearchText}
                pathname='/users/create'
                getList={getListUser}
                total={totalCount}
            />
            <UserTable
                handleDelete={handleDelete}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'Admin rights/functions' && value.isUpdate)
                }
                data={user}
                setData={setUser}
                total={totalCount}
                error={user.length}
                pagination={pagination}
                setPagination={setPagination}
                order={order}
                setOrder={setOrder}
            />
        </Box>
    );
}

export default UserList;